import React from 'react'
import {useParams} from "react-router-dom";
import {PageWrap} from "../../Components";
import VacationRequestForm from "../../Containers/Vacation/VacationRequestForm";

const VacationRequestUpdatePage = () => {
    const {id} = useParams<{id: string}>()
    return (
        <PageWrap>
            <h3>휴가신청서 수정</h3>
            <VacationRequestForm id={id}/>
        </PageWrap>
    )
}

export default VacationRequestUpdatePage
